






import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class UtxoStake extends Vue {
    @Prop() isStake!: boolean // UTXO was in the staking UTXO set (inputs/outputs/stakes)
}
